const selectSingle = document.querySelector(".wb-calculator__select");
const selectSingle_title = selectSingle.querySelector(
  ".wb-calculator__select__title"
);
const selectSingle_labels = selectSingle.querySelectorAll(
  ".wb-calculator__select__label"
);

// Toggle menu
selectSingle_title.addEventListener("click", () => {
  if ("active" === selectSingle.getAttribute("data-state")) {
    selectSingle.setAttribute("data-state", "");
  } else {
    selectSingle.setAttribute("data-state", "active");
  }
});

// Close when click to option
for (let i = 0; i < selectSingle_labels.length; i++) {
  selectSingle_labels[i].addEventListener("click", (evt) => {
    selectSingle_title.classList.add("checked");
    selectSingle_title.textContent = evt.target.textContent;
    selectSingle.setAttribute("data-state", "");
  });
}

window.theme.wbCalculator = {}

window.theme.wbCalculator.calculate = function () {
  let selectTitle = document.querySelector(".wb-calculator__select__title");
  let selectWeight = document.querySelector(".wb-calculator__weight__input");
  if (selectTitle.classList.contains("checked") && selectWeight.value) {
    var valueSnuggle = selectTitle.textContent;
    var weight = selectWeight.value;
    if (weight > 10 && weight < 80) {
      weight = 6;
    } else if (weight > 79 && weight < 100) {
      weight = 8;
    } else if (weight > 99 && weight < 150) {
      weight = 10;
    } else if (weight > 149 && weight < 200) {
      weight = 15;
    } else if (weight > 199 && weight < 250) {
      weight = 20;
    } else if (weight > 249 && weight < 300) {
      weight = 25;
    } else if (weight > 299 && weight < 350) {
      weight = 30;
    } else if (weight > 349) {
      weight = 35;
    };
  }
  var prodHandle = "";
  if (valueSnuggle) {
    window.theme.wbCalculator.back();
    let product = "";

    let preferens = "";
    switch (valueSnuggle) {
      case "Breathable and cool":
        product = "15 lbs Tree Napper";
        prodHandle = "tree-napper";
        preferens = "cooling";
        break;
      case "Warm and cozy":
        product = "15 lbs Velvet Napper";
        prodHandle = "velvet-napper";
        preferens = "cozy";
        break;
      case "Something in between":
        product = "15 lbs Cotton Napper";
        prodHandle = "the-napper";
        preferens = "breathable";
        break;
    }
    document.querySelector(`.product-${prodHandle}`).classList.remove("d-none");
    document.querySelector(`.product-${prodHandle}`).classList.add("last-product");
    swatches(prodHandle);
    document.querySelector(`.product-${prodHandle} .color-input`).click();
    document.querySelector(`.product-${prodHandle} .color-input`).click();
    let lbs = document.querySelectorAll(`.product-${prodHandle} .result-product`);
    lbs.forEach(function (item) {
      item.classList.add('d-none');
    })
    if (!document.querySelector('.' + prodHandle + '-' + weight)) {
      if (weight > 20) {
        document.querySelector(`.product-${prodHandle} .result-product:last-of-type`).classList.remove('d-none');
      }
      if (weight < 20) {
        document.querySelector(`.product-${prodHandle} .result-product`).classList.remove('d-none');
      }
    } else {
      document.querySelector('.' + prodHandle + '-' + weight).classList.remove('d-none');
    }
  }
  let varId = document.querySelector(`.product-${prodHandle} .res-image`).dataset.varid;
  let shopNow = document.querySelector('.shop-now');
  shopNow.setAttribute('href', `/products/${prodHandle}?variant=${varId}?utm_source=blog&utm_medium=calculator`);

  let url = window.location.origin;
  fetch(window.Shopify.routes.root + `products/${prodHandle}.js`).then((response) => {
    return response.json().then((product) => {
      document.querySelector('.results-colors-' + prodHandle).addEventListener("click", function (event) {
        if (event.target.dataset.color) {
          let color = event.target.dataset.pcolor;
          let musid = product.variants;
          for (let i = 0; i < musid.length; i++) {
            if (musid[i].title == color + ' / ' + weight) {
              document.querySelector('.buttons.shop-now').setAttribute('href', `/products/${prodHandle}?variant=${musid[i].id}`);
              break;
            } else if (musid.length - 1 == i) {
              for (let j = 0; j < musid.length; j++) {
                if (musid[j].title.includes(color)) {
                  document.querySelector('.buttons.shop-now').setAttribute('href', `/products/${prodHandle}?variant=${musid[j].id}`);
                  break;
                }
              }
            }
          }
        }
      });
    })
  })
}

window.theme.wbCalculator.back = function () {
  if (document.querySelector(".last-product")) {
    document.querySelector(".last-product").classList.add("d-none");
    document.querySelector(".last-product").classList.remove("last-product");
  }
  document.querySelector("#weight").classList.toggle("d-none");
  document.querySelector(".wb-calculator__select").classList.toggle("d-none");
  document.querySelector(".buttons.calculate").classList.toggle("d-none");
  document.querySelector(".buttons.back").classList.toggle("d-none");
  document.querySelector(".buttons.shop-now").classList.toggle("d-none");
}

function swatches(prodHandle) {
  document.querySelector(".results-colors-" + prodHandle).addEventListener("click", function (event) {
    if (event.target.dataset.color) {
      let allImgs = document.querySelectorAll('.res-image');
      allImgs.forEach(function (item) {
        item.classList.add('d-none');
      })
      let allInputs = document.querySelectorAll('.color-input');
      allInputs.forEach(function (item) {
        item.classList.remove('checked');
      })
      let dataColor = event.target.dataset.color;
      let resultsImg = document.querySelector(".results-image-" + prodHandle);
      resultsImg.querySelector("." + dataColor.replace('color-', '')).classList.remove("d-none");
      event.target.classList.add('checked');
    }
  });
}
